"use client";

import { useEffect } from "react";
import {
  BIEvents,
  trackEvent,
} from "@/_components/lib/mixpanel/mixpanelClient";

interface TrackBlogOpenEventProps {
  title: string;
  url?: string;
}

export const TrackBlogOpenEvent = ({ title, url }: TrackBlogOpenEventProps) => {
  useEffect(() => {
    trackEvent(BIEvents.BLOG_OPEN_ARTICLE, {
      title,
      ...(url ? { url } : {}),
    });
  }, [title, url]);

  return null;
};
